import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  /** Keep track of all pending loaders. Helps prevent a faster response from hiding the spinner before slower responses */
  private _pending: boolean[] = [];

  private _loading$ = new BehaviorSubject<boolean>(false);
  /** Observable that emits true if any requests are still pending */
  loading$ = this._loading$.asObservable();

  /** Start or stop the spinner by setting loading to true/false */
  set loading(pending: boolean) {
    if (pending) {
      this._pending.push(pending);
    } else {
      this._pending.pop();
    }
    this._loading$.next(this._pending.length > 0);
  }
}
